export default __webpack_public_path__ + "static/media/conference-user-remove.58819fd0.svg";